module.exports = __webpack_public_path__ + "img/menu-icon-1-3.b8f40a72.svg";